import styled from '@emotion/styled';
import type { ReactNode } from 'react';
import { FullScreenHeader } from './FullScreenHeader/FullScreenHeader';

const FullScreen = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: scroll;
`;

export interface FullScreenViewProps {
  children: ReactNode;
  title: string;
  onClose: () => void;
  contextActions?: ReactNode;
}

export const FullScreenView = ({
  children,
  title,
  onClose,
  contextActions,
}: FullScreenViewProps): JSX.Element => {
  return (
    <FullScreen>
      <FullScreenHeader title={title} onClose={onClose} contextActions={contextActions} />
      {children}
    </FullScreen>
  );
};
